import { render, staticRenderFns } from "./SText.vue?vue&type=template&id=43a0908a"
import script from "./SText.vue?vue&type=script&lang=js"
export * from "./SText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports